import { ChangeEvent, JSX, useContext } from "react";
import { BulkTargetingWizardContext } from "../TargetingWizardContext";
import { QESCheckbox } from "@app/shared/qes-standards/forms/Checkbox";

interface ReportCheckboxProps {
  reportKey: string;
  label: string;
}

const ReportCheckbox = ({ reportKey, label }: ReportCheckboxProps): JSX.Element => {
  const wizardContext = useContext(BulkTargetingWizardContext);
  
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const isSelected = e.target.checked;
    const currentReports = wizardContext.selectedReports || [];
    if (isSelected) {
      wizardContext.setSelectedReports([...currentReports, reportKey]);
    } else {
      wizardContext.setSelectedReports(currentReports.filter(r => r !== reportKey));
    }
  };

  return (
    <QESCheckbox
      label={label}
      id={`report-${reportKey}`}
      checked={wizardContext.selectedReports?.includes(reportKey) || false}
      onChange={handleChange}
      testId={`volume-reports__${reportKey}`}
      containerClassName="me-3"
    />
  );
};

export default ReportCheckbox;